import React from "react";
import useAuth from "./hooks/useAuth";
import { useState, useEffect } from "react";
import Select from 'react-select'

const CheckUserDates = ({ selectHandler, language, checkuser, value, disabled }) => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  const {auth, setAuth} = useAuth();  

  const getFiles = async () => {
    if (!language) return;
    
    setLoading(true);
    const fetchData = async (route, method) => {
      const token = localStorage.getItem("token");
      const url = `${process.env.REACT_APP_USER_API_URL}/analysis/${route}` 
      const response = await fetch(url, {
          method: method,
          headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
          }
      });
      if (response.status === 401) {
          localStorage.removeItem("token");
          setAuth({});
          return null;
      }
      if (response.ok) {
          const json = await response.json();
          return json;
      }
      return null
    }
    
    var json = ""
    if (checkuser) {
      json = await fetchData(`${language}/list_dates?checkuser=${checkuser}`, "GET");
    } else {
      json = await fetchData(`${language}/list_dates`, "GET");
    }
    
    if (json) {
        let dates = [{'value':'All records', 'label': 'All records'}]
        json.map((item,i)=>{
          dates.push({'value':item, 'label': item})
        })
        setData(dates);
    }
    setLoading(false);
  }

  useEffect(()=>{
    if (language) {
      getFiles()
    }
  },[language])

  // Handle initial setup - when disabled and value is "All records", ensure it's set
  useEffect(() => {
    if (disabled && value === 'All records' && data) {
      // Make sure "All records" is properly selected
      const allRecordsOption = data.find(option => option.value === 'All records');
      if (allRecordsOption) {
        // This ensures the dropdown shows "All records" even when disabled
      }
    }
  }, [disabled, value, data]);

  if (!language) {
    return (
      <Select 
        options={[]}
        placeholder="Select language first"
        isDisabled={true}
        className="text-sm"
        styles={{
          control: (base) => ({
            ...base,
            minHeight: '44px',
            borderColor: '#d1d5db',
            borderRadius: '8px',
            backgroundColor: '#f9fafb'
          }),
          placeholder: (base) => ({
            ...base,
            color: '#9ca3af',
            fontSize: '14px'
          })
        }}
      />
    )
  }

  if (loading) return ( 
    <div className="flex items-center justify-center py-3">
      <div className="flex items-center gap-2 text-gray-500">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-green-500"></div>
        <span className="text-sm">Loading dates...</span>
      </div>
    </div>
  )

  if (!data || data.length === 0) return (
    <div className="text-center py-3 text-gray-500 text-sm">
      No dates available
    </div>
  )

  // Create the current value - handle both when disabled with "All records" and normal selection
  const currentValue = data.find(option => option.value === value) || 
                      (disabled && value === 'All records' ? { value: 'All records', label: 'All records' } : null) ||
                      { value: 'Select date', label: 'Select date' };

  return (
    <Select 
      onChange={selectHandler}
      options={data}
      value={currentValue}
      isDisabled={disabled}
      placeholder={disabled && value === 'All records' ? "All records (auto)" : "Select date"}
      className="text-sm"
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: '44px',
          borderColor: state.isFocused ? '#10b981' : '#d1d5db',
          borderRadius: '8px',
          backgroundColor: disabled ? '#f9fafb' : 'white',
          boxShadow: state.isFocused ? '0 0 0 1px #10b981' : 'none',
          '&:hover': {
            borderColor: state.isFocused ? '#10b981' : disabled ? '#d1d5db' : '#9ca3af'
          },
          transition: 'all 0.2s ease-in-out',
          opacity: disabled ? 0.7 : 1
        }),
        menu: (base) => ({
          ...base,
          borderRadius: '8px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
          zIndex: 50
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected ? '#10b981' : state.isFocused ? '#ecfdf5' : 'white',
          color: state.isSelected ? 'white' : '#374151',
          fontSize: '14px',
          padding: '8px 12px',
          '&:active': {
            backgroundColor: '#059669'
          }
        }),
        placeholder: (base) => ({
          ...base,
          color: '#9ca3af',
          fontSize: '14px'
        }),
        singleValue: (base, state) => ({
          ...base,
          color: disabled ? '#6b7280' : '#374151',
          fontSize: '14px',
          fontWeight: '500'
        }),
        dropdownIndicator: (base, state) => ({
          ...base,
          color: state.isFocused ? '#6b7280' : '#9ca3af',
          '&:hover': {
            color: '#6b7280'
          },
          opacity: disabled ? 0.5 : 1
        }),
        indicatorSeparator: (base) => ({
          ...base,
          backgroundColor: '#e5e7eb',
          opacity: disabled ? 0.5 : 1
        })
      }}
    />
  );
};

export default CheckUserDates;